import { Component, Vue } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'
import moment from 'moment'

import AccessModel from '@/core/models/AccessModel'
import ApiRequest from '@/core/ApiRequest'
import { GET_API_REQUEST, GET_ACCESS_MODEL } from '@/store/root/getters'
import { ADD_HOLIDAY, DELETE_HOLIDAY, FETCH_HOLIDAY } from '@/store/root/actions'

import EventsList from '@/components/shared/events-list/EventsList.vue'
import CallsList from '@/components/shared/calls-list/CallsList.vue'

@Component({
  components: { EventsList, CallsList }
})
export default class DayEvents extends Vue {
  public events: Array<any> = []
  public calls: Array<any> = []
  public holiday: Object | null = null

  /**
   * Get api request object, based on global Vuex state.
   */
  @Getter(GET_API_REQUEST)
  public getApiRequest: ApiRequest

  /**
   * Get access model, based on global Vuex state.
   */
  @Getter(GET_ACCESS_MODEL)
  public getAccessModel: AccessModel | null

  /**
   * Fetch holiday.
   */
  @Action(FETCH_HOLIDAY)
  public fetchHoliday: (day: string) => Object | null

  /**
   * Add holiday.
   */
  @Action(ADD_HOLIDAY)
  public addHoliday: (payload: { day: string, text: string }) => void;

  /**
   * Delete holiday.
   */
  @Action(DELETE_HOLIDAY)
  public deleteHoliday: (day: string) => void;


  public getDateTitle (): string {
    const routeDate = new Date(this.$route.params.date)
    return moment(routeDate.toISOString()).format('LL')
  }

  public addNewEvent () {
    const thisDayDate = new Date(this.$route.params.date)
    this.$router.push({
      name: 'addEvent',
      query: { date: moment(thisDayDate.toISOString()).format('YYYY-MM-DD') }
    })
  }

  public addNewCall () {
    const thisDayDate = new Date(this.$route.params.date)
    this.$router.push({
      name: 'addCall',
      query: { date: moment(thisDayDate.toISOString()).format('YYYY-MM-DD') }
    })
  }

  public async onAddHoliday () {
    const day = moment(this.$route.params.date).format('YYYY-MM-DD')
    await this.addHoliday({ day, text: '' })
    this.holiday = await this.fetchHoliday(day)
  }

  public async onDeleteHoliday () {
    const day = moment(this.$route.params.date).format('YYYY-MM-DD')
    await this.deleteHoliday(day)
    this.holiday = await this.fetchHoliday(day)
  }

  /**
   * Created lifecycle hook. Fires when component instance is created.
   */
  public async created () {
    this.holiday = await this.fetchHoliday(moment(this.$route.params.date).format('YYYY-MM-DD'))

    const responseCall = await this.getApiRequest.send(
      'GET',
      'calls?date_from=' +
      encodeURIComponent((new Date(`${this.$route.params.date}T00:00:00`)).toISOString()) +
      '&date_to=' +
      encodeURIComponent((new Date(`${this.$route.params.date}T23:59:59`)).toISOString()),
    )
    this.calls = []
    if (responseCall && responseCall.data) {
      this.calls = responseCall.data
    }

    const responseEvents = await this.getApiRequest.send(
      'GET',
      'events?date_from=' +
      encodeURIComponent((new Date(`${this.$route.params.date}T00:00:00`)).toISOString()) +
      '&date_to=' +
      encodeURIComponent((new Date(`${this.$route.params.date}T23:59:59`)).toISOString()),
    )
    this.events = []
    if (responseEvents && responseEvents.data) {
      this.events = responseEvents.data
    }
  }
}
